export const QUERY_KEY_VARIANTS = {
  LIST: 'list',
  DETAIL: 'detail',
};
